import { render, staticRenderFns } from "./MainShow.vue?vue&type=template&id=78bf9900&scoped=true"
import script from "./MainShow.vue?vue&type=script&lang=js"
export * from "./MainShow.vue?vue&type=script&lang=js"
import style0 from "./MainShow.vue?vue&type=style&index=0&id=78bf9900&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bf9900",
  null
  
)

export default component.exports